import axios from 'axios';
import { API_URL } from '../../lib/const';

export const approveTermOfAbsence = token => (
  axios.post(`${API_URL}/onboarding/enrollments/${token}/approve_term_of_absence`)
    .then(response => response.data)
)

export default approveTermOfAbsence;
